const defaultTheme = require('tailwindcss/defaultTheme');

module.exports = {
  purge: {
    content: ['**/**/*.php'],
  },
  darkMode: false, // or 'media' or 'class'
  theme: {
    extend: {
      colors: {
        inherit: 'inherit',
        'lightgrey': '#C6C6C6',
        'darkgrey': '#BFC7C4',
      },
      screens: {
        'md': '769px',
        'lg': '1025px',
        '3xl': '1800px',
        '5xl': '5000px',
        'retina': {
          'raw': 'only screen and (min-width: 1025px) and (-webkit-min-device-pixel-ratio: 2), only screen and (min-width: 1025px) and (min-resolution: 192dpi)'
        },
        'retina-lg': {
          'raw': 'only screen and (min-width: 2500px) and (-webkit-min-device-pixel-ratio: 2), only screen and (min-width: 2500px) and (min-resolution: 192dpi)'
        },
      },
      lineHeight: {
        'header': '1.15',
        'xl': '1.4',
      }
    },
    borderColor: theme => ({
      ...theme('colors'),
      DEFAULT: theme('currentColor'),
    }),
    fontFamily: {
      'sans': ['West', ...defaultTheme.fontFamily.sans],
    },
    fontSize: {
      ...defaultTheme.fontSize,
      'base': ['1rem', '1.29'],
      'lg': '1.5rem',
      'xl': ['1.29rem', '1.19'],
      '2xl': '1.75rem',
      '3xl': ['2rem', '1.16'],
      '4xl': '2.375rem',
      '5xl': ['3rem', '1.15'],
      '6xl': '3.7rem',
      '7xl': '4.6875rem',
      '9xl': '7rem',
    }
  },
  variants: {
    extend: {},
  },
  plugins: [
    require('@tailwindcss/aspect-ratio'),
  ],
}
